export const mapHolidayDto = (dto) => ({
    id: dto.id,
    userId: dto.userId,
    displayName: dto.user.name,
    startDate: dto.startDate,
    endDate: dto.endDate,
    numberDays: dto.numberDays
});

